import React, { useState } from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { useImpressionItem } from '@fiverr-private/impressionable';
import { Heading, Typography } from '@fiverr-private/typography';
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@fiverr-private/navigation';
import { FiverrProLightLogo } from '@fiverr-private/visuals';
import { BQ_IMP_FIP_IS_SHOWN } from '../../utils/biEvents/events/bigQueryEvents';
import { getImpressionEnrichment } from '../../utils/biEvents';
import { FiverrPackage } from './FiverrPackage';
import { FiverrProPackage } from './FiverrProPackage';
import { packagesTitleClass } from './styles.ve.css';

const COPY_KEY_PREFIX = 'logged_out_homepage.pro_packages_banner';

const ProPackagesBannerB = () => {
    const [ref] = useImpressionItem(getImpressionEnrichment({ eventName: BQ_IMP_FIP_IS_SHOWN }));
    const [selectedIndex, setSelectedIndex] = useState(0);
    const proPackageSelected = selectedIndex === 0;
    const fiverrPackageSelected = selectedIndex === 1;
    const handleTabChange = (index: number) => setSelectedIndex(index);

    return (
        <Stack
            data-testid="pro-packages-banner-b"
            ref={ref}
            direction={{
                default: 'column',
                lg: 'row',
            }}
            gap={{
                default: '8',
                md: '12',
                lg: '8',
                xl: '20',
            }}
            paddingX={{
                default: '8',
                lg: '10',
                xl: '16',
            }}
            paddingY={{
                default: '12',
                xl: '16',
            }}
            justifyContent={{
                default: 'flexStart',
                md: 'spaceBetween',
            }}
            borderRadius="3xl"
            style={{
                background: 'linear-gradient(180deg, #013A13 50%, #000000 100%)',
            }}
        >
            <Stack direction="column" gap="4" justifyContent="center" maxWidth="580px" position="relative">
                <Container position="absolute" left={0} top={0}>
                    <FiverrProLightLogo />
                </Container>
                <Heading
                    as="h2"
                    className={packagesTitleClass}
                    color="white"
                    marginTop={{
                        default: '14',
                        lg: '0',
                    }}
                >
                    <I18n k={`${COPY_KEY_PREFIX}.title`} />
                </Heading>
                <Typography color="white">
                    <I18n k={`${COPY_KEY_PREFIX}.description`} />
                </Typography>
            </Stack>
            <Container
                direction="row"
                gap={{
                    default: '6',
                    lg: '6',
                    xl: '8',
                }}
                display={{
                    default: 'none',
                    md: 'flex',
                }}
            >
                <FiverrPackage />
                <FiverrProPackage />
            </Container>
            <Container
                display={{
                    default: 'block',
                    md: 'none',
                }}
            >
                <TabGroup isStretched onChange={handleTabChange} selectedIndex={selectedIndex}>
                    <TabList>
                        <Tab>
                            <Typography
                                color={proPackageSelected ? 'white' : 'grey_500'}
                                fontWeight={proPackageSelected ? 'bold' : 'semibold'}
                            >
                                <I18n k={`${COPY_KEY_PREFIX}.fiverr_pro_package.alt_title`} />
                            </Typography>
                        </Tab>
                        <Tab>
                            <Typography
                                color={fiverrPackageSelected ? 'white' : 'grey_500'}
                                fontWeight={fiverrPackageSelected ? 'bold' : 'semibold'}
                            >
                                <I18n k={`${COPY_KEY_PREFIX}.fiverr_package.title`} />
                            </Typography>
                        </Tab>
                    </TabList>
                    <TabPanels>
                        <TabPanel>
                            <Container paddingTop="4">
                                <FiverrProPackage />
                            </Container>
                        </TabPanel>
                        <TabPanel>
                            <Container paddingTop="4">
                                <FiverrPackage />
                            </Container>
                        </TabPanel>
                    </TabPanels>
                </TabGroup>
            </Container>
        </Stack>
    );
};

export default ProPackagesBannerB;
